/**
 * @file
 * Squircle script.
 */

(function squircleScript($, Drupal, drupalSettings) {
  'use strict';

  var randomProperty = function (object) {
    // Grab random element from the JSON list.
    var keys = Object.keys(object);
    var randomKey = Math.floor(keys.length * Math.random());
    return {key: randomKey, object: object[keys[randomKey]]};
  };

  Drupal.behaviors.squircle = {
    attach: function squircleAttach(context) {
      var $ballPit = $('.tip-grid__layout', context);
      if (!$ballPit.length) {
        return;
      }

      $('.squircle', context).on('mouseleave', function () {
        $(this).animateCss('pulse');
      });

      if (typeof (drupalSettings.tipsJson) === 'undefined') {
        return;
      }
      var jsonList = drupalSettings.tipsJson;
      if (!jsonList.length || typeof (jsonList) !== 'object') {
        return;
      }

      // On page load, randomize which tips are shown.
      $('.squircle--tip', context).each(function () {
        var $this = $(this);
        var randomItem = randomProperty(jsonList);
        // Remove selected tip from JSON list, so we don't get repeats.
        jsonList.splice(randomItem.key, 1);
        $this.find('.squircle__label').text(Drupal.t('Tip') + ' ' + randomItem.object.nid);
        $this.find('.squircle__headline').text(randomItem.object.field_tip_text);
      });

      // When user clicks to close a Tip, it will zoom out, update text and ID,
      // then bounces back in. The Masonry layout will adjust accordingly.
      $('.squircle__close-button', context).hammer().on('tap press click', function () {
        var $tip = $(this).parent();
        var randomItem = randomProperty(jsonList);
        var dataLayer = window.dataLayer = window.dataLayer || [];

        if (drupalSettings.pin_analytics && drupalSettings.pin_analytics.squircle && window.ga && window.ga.loaded) {
          // GA tracking of close button
          window.ga('send', {
            hitType: 'event',
            eventCategory: 'tip',
            eventAction: 'click',
            eventLabel: 'homepage'
          });
          // GA4 tracking of close button
          dataLayer.push({
            event: 'tip_closed',
            entity_type: 'tip',
            entity_id: $tip.data('entity-id')
          });
        }

        // Remove selected tip from JSON list, so we don't get repeats.
        jsonList.splice(randomItem.key, 1);

        if (jsonList.length) {
          $tip.animateCss('zoomOut', function () {
            $tip.find('.squircle__label').text(Drupal.t('Tip') + ' ' + randomItem.object.nid);
            $tip.find('.squircle__headline').text(randomItem.object.field_tip_text);
            if ($ballPit.length) {
              // Update Masonry layout.
              $ballPit.masonry('layout');
            }
            $tip.animateCss('bounceIn');
          });
        }
      });
    }
  };
}(jQuery, Drupal, drupalSettings));
